import api from '~/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getRetailer(_, id) {
    return api.get(`retailers/${id}`)
  },
  getRetailers(_, id) {
    return api.get('retailers?perPage=500')
  },
  createRetailer(_, { form, options }) {
    return api.post('retailers', form, options)
  },
  updateRetailer(_, { form, options }) {
    return api.put(`retailers/${form.id}`, form, options)
  },
  deleteRetailer(_, id) {
    return api.delete(`retailers/${id}`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
